<template>

<app-content :loading="is.loading && !is.initialised">

	<app-content-head title="Conventions" subtitle="Browse conventions and view them in other modes." />

	<app-content-filters>

		<app-content-filters-search v-model="filter.search" />

		<app-content-filters-tags v-model="filter.tags" :options="filterTags" />

	</app-content-filters>

	<app-content-body :loading="is.loading && is.initialised" :is-empty="!collection.length" placeholder="Sorry, no conventions found.">

		<app-table>

			<app-table-head :layout="layout">

				<app-table-column />
				<app-table-column text="Name" />
				<app-table-column align="center" text="Starts" />
				<app-table-column align="center" text="Ends" />
				<app-table-column text="Organization" />
				<app-table-column text="Owner" />

			</app-table-head>

			<app-table-body>

				<app-table-row v-on:click="onEditClick(item.id)" :layout="layout" v-for="item in collection" :key="item.id">
					
					<app-table-cell-label :text="$constants.convention.statusName[item.status]" :type="$constants.convention.statusTheme[item.status]" :subtext="item.reference" />

					<app-table-cell-text :text="item.name" />

					<app-table-cell-text align="center" :text="item.date.start | localDate('MM/DD/YYYY')" />

					<app-table-cell-text align="center" :text="item.date.end | localDate('MM/DD/YYYY')" />
					
					<app-table-cell-item :item="item.organisation" type="organisation" />
					
					<app-table-cell-item :item="item.user" type="user" />

				</app-table-row>

			</app-table-body>

			<app-table-foot :pagination="pagination" :total="total" />

		</app-table>

	</app-content-body>

</app-content>

</template>

<script>

import mixCollection from '@/mixin/collection'

export default {

	mixins: [mixCollection],

	data: function() {

		return {
			filter: {
				tags: [2,3]
			},
			filterTags: [
				{ text: 'Active', value: 2, theme: 'green' },
				{ text: 'Running', value: 3, theme: 'blue' },
				{ text: 'Finished', value: 4, theme: 'grey' },
				{ text: 'Cancelled', value: 5, theme: 'red' }
			],
			layout: '120px auto 120px 120px 240px 240px',
			endpoint: 'conventions/conventions',
			live: 'conventions/conventions',
			edit: 'Conventions.Browse.Edit',
		}

	}

}

</script>

<style scoped>

</style>